import { css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { estimateCountryCode, getFlagEmoji2, supportsFlagEmoji } from '../functions/flag';
import { LitHauntedElement } from '../mixins/lit-haunted-element';
import { useEffect } from 'haunted';
import { isNullishOrWhitespace } from '../functions/nullish';

@customElement('ep-flag')
export class EPFlag extends LitHauntedElement {

  /**
   * Country Code
   * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
   */
  @property({ attribute: 'iso3166', reflect: true })
  iso3166?: string;

  /**
   * Language Code
   * https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
   */
  @property({ attribute: 'iso639', reflect: true })
  iso639?: string;

  supportsFlagEmoji = supportsFlagEmoji();

  render() {
    useEffect(() => {
      if(this.iso639 !== undefined) {
        this.iso3166 = estimateCountryCode(this.iso639);
      }
    }, [this.iso639])

    if (this.iso3166 === undefined) {
      return html`❔`
    }

    if (this.supportsFlagEmoji) {
      return html`<span style="display: inline-block;">${getFlagEmoji2(this.iso3166)}</span>`
    }
    else if (isNullishOrWhitespace(this.iso3166)) {
      return html`<span style="display: inline-block;">🌐</span>`
    }
    else {
      return html`<img src="https://flagicons.lipis.dev/flags/4x3/${this.iso3166.toLowerCase()}.svg" />`
    }
  }

  static styles = css`
    :host {
      display: inline-flex;
      box-shadow: 0px 0px 1px #929292;
    }
    img {
      height: 1em;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-flag': EPFlag
  }
}
